import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import RouteErrorBoundary from './components/core/RouteErrorBoundary.tsx';
import { lazy } from 'react';

const Login = lazy(() => import('./components/Login.tsx'));
const LogoutPage = lazy(() => import('./components/LogoutPage.tsx'));
const DevPage = lazy(() => import('./components/DevPage.tsx'));
const Go = lazy(() => import('./components/Go.tsx'));
const UserComponent = lazy(() => import('./components/UserComponent.tsx'));
const Layout = lazy(() => import('./components/Layout.tsx'));
const HomePage = lazy(() => import('./components/HomePage.tsx'));
const HelpPage = lazy(() => import('./components/HelpPage.tsx'));
const SupplierLeadingIndicatorsPage = lazy(() => import('./components/lighthouse/SupplierLeadingIndicatorsPage.tsx'));
const PublicLinksPage = lazy(() => import('./components/PublicLinksPage.tsx'));
const UserManagementPage = lazy(() => import('./components/userManagement/UserManagementPage.tsx'));
const TechnicalCapabilitiesPage = lazy(() => import('./components/technicalCapabilities/TechnicalCapabilitiesPage.tsx'));
const ActionItems = lazy(() => import('./components/actionItems/ActionItems.tsx'));
const BufferstockPage = lazy(() => import('./components/bufferstock/BufferstockPage.tsx'));
const ActionItemForm = lazy(() => import('./components/actionItems/ActionItemForm.tsx'));
const ScoreCardPage = lazy(() => import('./components/scorecard/ScoreCardPage.tsx'));
const SbuPage = lazy(() => import('./components/sbu/SbuPage.tsx'));
const SiteDetailsPage = lazy(() => import('./components/SiteDetailsPage.tsx'));
const ImpersonatePage = lazy(() => import('./components/ImpersonatePage.tsx'));

const pageRoutes = [
    {
        path: '/',
        element: <Login />,
        errorElement: <RouteErrorBoundary />,
    },
    {
        path: '/Login',
        element: <Login />,
        errorElement: <RouteErrorBoundary />,
    },
    {
        path: '/LogoutPage',
        element: <LogoutPage />,
        errorElement: <RouteErrorBoundary />,
    },
    {
        path: '/DevPage',
        element: <DevPage />,
        errorElement: <RouteErrorBoundary />,
    },
    {
        path: '/Go',
        element: <Go />,
        errorElement: <RouteErrorBoundary />,
    },
    {
        path: '/WorkspacePage',
        element: (
            <UserComponent>
                <Layout pageName="Welcome to the Supplier Collaboration Platform">
                    <HomePage />
                </Layout>
            </UserComponent>
        ),
        errorElement: <RouteErrorBoundary />,
    },
    {
        path: '/HelpPage',
        element: (
            <UserComponent>
                <Layout pageName="Help">
                    <HelpPage />
                </Layout>
            </UserComponent>
        ),
        errorElement: <RouteErrorBoundary />,
    },
    {
        path: '/SupplierLeadingIndicatorsPage',
        element: (
            <UserComponent>
                <Layout pageName="Supplier Leading Indicators">
                    <SupplierLeadingIndicatorsPage />
                </Layout>
            </UserComponent>
        ),
        errorElement: <RouteErrorBoundary />,
    },
    {
        path: '/PublicLinksPage',
        element: <PublicLinksPage />,
        errorElement: <RouteErrorBoundary />,
    },
    {
        path: '/UserManagementPage',
        element: (
            <UserComponent>
                <Layout pageName="User Management">
                    <UserManagementPage />
                </Layout>
            </UserComponent>
        ),
        errorElement: <RouteErrorBoundary />,
    },
    {
        path: '/TechnicalCapabilitiesPage',
        element: (
            <UserComponent>
                <Layout pageName="Technical Capabilities">
                    <TechnicalCapabilitiesPage />
                </Layout>
            </UserComponent>
        ),
        errorElement: <RouteErrorBoundary />,
    },
    {
        path: '/ActionItems',
        element: (
            <UserComponent>
                <Layout pageName="Action Items">
                    <ActionItems />
                </Layout>
            </UserComponent>
        ),
        errorElement: <RouteErrorBoundary />,
    },
    {
        path: '/Inventory_AR',
        element: (
            <UserComponent>
                <Layout pageName="Inventory Availability & Readiness">
                    <BufferstockPage />
                </Layout>
            </UserComponent>
        ),
        errorElement: <RouteErrorBoundary />,
    },
    {
        path: '/ActionItemForm',
        element: (
            <UserComponent>
                <Layout pageName="Action Item Form">
                    <ActionItemForm />
                </Layout>
            </UserComponent>
        ),
        errorElement: <RouteErrorBoundary />,
    },
    {
        path: '/ScorecardPage',
        element: (
            <UserComponent>
                <Layout pageName="Scorecard">
                    <ScoreCardPage />
                </Layout>
            </UserComponent>
        ),
        errorElement: <RouteErrorBoundary />,
    },
    {
        path: '/SbuPage',
        element: (
            <UserComponent>
                <Layout pageName="">
                    <SbuPage />
                </Layout>
            </UserComponent>
        ),
        errorElement: <RouteErrorBoundary />,
    },
    {
        path: '/SiteDetailsPage',
        element: (
            <UserComponent>
                <Layout pageName="Site Details">
                    <SiteDetailsPage />
                </Layout>
            </UserComponent>
        ),
        errorElement: <RouteErrorBoundary />,
    },
    {
        path: '/ImpersonatePage',
        element: (
            <UserComponent>
                <Layout pageName="Impersonate">
                    <ImpersonatePage />
                </Layout>
            </UserComponent>
        ),
        errorElement: <RouteErrorBoundary />,
    },
];

export function CustomRouterProvider() {
    const router = createBrowserRouter(pageRoutes);
    return <RouterProvider router={router} />;
}
